import { configureStore } from '@reduxjs/toolkit';

import appReducer from './features/app/appSlice';
import orderReducer from './features/orderSlice/orderSlice';
import productReducer from './features/productSlice/productSlice';
import expensesReducer from './features/expenseSlice/expenseSlice';
import customerReducer from './features/customerSlice/customerSlice';

export const store = configureStore({
  reducer: {
    app: appReducer,
    orders: orderReducer,
    products: productReducer,
    customers: customerReducer,
    expenses: expensesReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
